import axios from "./_axios";
import { API } from "./apiEndPoints";
import { refreshAccountCounts } from "@/utils/accountCountUtils";
import configService from "@/services/config";
import qs from "qs";

export const getListOfPositions = async (account_id, page_no, size) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/position/`,
    params: { page: page_no, size: size },
  });
  return result;
};
export const getListOfPositionsForAssignment = async ({
  accountId,
  limit,
  offset,
  name,
  effectiveFrom,
  effectiveTo,
}) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${accountId}/position/`,
    params: {
      limit,
      offset,
      name,
      ordering: "name",
      effective_from: effectiveFrom || undefined,
      effective_to: effectiveTo || undefined,
    },
    paramsSerializer: (params) => {
      return qs.stringify(
        { ...params, status: ["active", "draft", "retired"] },
        { arrayFormat: "repeat" }
      );
    },
  });
  return result;
};
export const getListOfPositionsForPrepareAssignment = async ({
  accountId,
  limit,
  offset,
  name,
}) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${accountId}/position/`,
    params: { limit, offset, name, ordering: "name", status: "active" },
  });
  return result;
};

//https://api.dev.exiqtive.com/api/proficiency/v2/account/2/position/
export const getListOfPositionsV2 = async ({ account_id, queryParamsObj }) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/`,
    params: { ...queryParamsObj },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
  return result;
};

// Readiness > Positions list — GET /v2/account/{id}/position/readiness/
// Same query-param pattern as the Employees readiness list (vacancy, exclude_from_avg,
// department_id, department_scope, name, ordering, limit/offset). Only ACTIVE
// positions are ever returned (server-filtered).
export const getPositionsReadiness = async ({ account_id, queryParamsObj }) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/${API.POSITION_READINESS}`,
    params: { ...queryParamsObj },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
  return result;
};

export const createPosition = async (account_id, data) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/`,
    data: data,
  });
  // ER-12439: a new position starts unassigned, so it changes the orphan count.
  await refreshAccountCounts(account_id);
  return result;
};

/** POST /api/common/v2/account/<id>/position/<position_id>/clone/ (ER-11675 / ER-11848) */
export const clonePosition = (account_id, position_id) => {
  return axios()({
    method: "post",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/${position_id}/clone/`,
  });
};
export const updatePosition = (account_id, position_id, data) => {
  let result = axios()({
    method: "put",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/${position_id}/`,
    data: data,
  });
  return result;
};

/**
 * POST /api/common/v2/account/<id>/position/<position_id>/set-job-family/
 * Links a Position to exactly one Job Family + Level (MDP-581 §2). Gated by the
 * `idea-MDP-581` flag (404 when off). Body: `{ job_family_id, job_family_level_id }`.
 */
export const setJobFamily = (account_id, position_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/${position_id}/set-job-family/`,
    data: data,
  });
  return result;
};

/**
 * POST /api/common/v2/account/<id>/position/<position_id>/unassign-job-family/
 * Clears the Position's Job Family + Level link (MDP-581 §2/§14). Idempotent.
 */
export const unassignJobFamily = (account_id, position_id) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/${position_id}/unassign-job-family/`,
  });
  return result;
};

export const addPositionAssignment = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/position-assignment/add/`,
    data: data,
  });
  return result;
};
export const updatePositionAssignment = (account_id, data, id) => {
  let result = axios()({
    method: "patch",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position-assignment/${id}/`,
    data: data,
  });
  return result;
};
export const deletePosition = async (account_id, position_id) => {
  let result = await axios()({
    method: "delete",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/${position_id}/`,
  });
  // ER-12439: deleting a position can remove an orphan from the count.
  await refreshAccountCounts(account_id);
  return result;
};
export const attachRoleToPosition = (account_id, roleId, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/${roleId}/attach/`,
    data: data,
  });
  return result;
};
export const getPositionChatter = (account_id, position_id, page_no) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/position/${position_id}/chatter/`,
    params: { page: page_no },
  });
  return result;
};
export const updatePositionExcludeValue = (account_id, position_id, data) => {
  let result = axios()({
    method: "patch",
    url: `${API.ACCOUNTList}${account_id}/position/${position_id}/`,
    data: data,
  });
  return result;
};
export const activatePosition = async (account_id, position_id) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/${position_id}/activate/`,
  });
  await refreshAccountCounts(account_id);
  return result;
};
export const deActivatePosition = async (account_id, position_id) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/${position_id}/de-activate/`,
  });
  await refreshAccountCounts(account_id);
  return result;
};
export const reActivatePosition = async (account_id, position_id) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/${position_id}/re-activate/`,
  });
  await refreshAccountCounts(account_id);
  return result;
};
export const retirePosition = async (account_id, position_id) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/position/${position_id}/retire/`,
  });
  await refreshAccountCounts(account_id);
  return result;
};
export const archivePosition = async (account_id, objType, orgId) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/${objType}/${orgId}/archive/`,
  });
  await refreshAccountCounts(account_id);
  return result;
};
export const unArchivePosition = async (account_id, objType, orgId) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/${objType}/${orgId}/unarchive/`,
  });
  await refreshAccountCounts(account_id);
  return result;
};

export const getPositionAssignments = (
  account_id,
  employee_id,
  page = 1,
  size = 10,
  status = null
) => {
  let result = axios()({
    method: "get",
    url: `${
      API.ACCOUNT_LIST_V2
    }${account_id}/position-assignment/?employee=${employee_id}&page=${page}&size=${size}${
      status ? `&status=${status}` : ""
    }`,
  });
  return result;
};

/**
 * Fetch position assignment history for a position (current and relieved).
 * @param {number|string} account_id
 * @param {number|string} position_id
 * @param {object} options - { limit, offset, status }
 */
export const getPositionAssignmentsByPositionId = (account_id, position_id, options = {}) => {
  const { limit = 100, offset = 0, status = null } = options;
  let url = `${API.ACCOUNT_LIST_V2}${account_id}/position-assignment/?position=${position_id}&limit=${limit}&offset=${offset}`;
  if (status) {
    if (Array.isArray(status)) {
      status.forEach((s) => {
        url += "&status=" + encodeURIComponent(s);
      });
    } else {
      url += "&status=" + encodeURIComponent(status);
    }
  }
  return axios()({
    method: "get",
    url,
  });
};

/** PATCH reorder roles on a position. Body: `{ role_order: number[] }` (all role ids for the position, in order). */
export const reorderRolesOnPosition = (account_id, position_id, data) => {
  return axios()({
    method: "patch",
    url: `${API.PROFICIENCY_V2}${account_id}/position/${position_id}/reorder-role`,
    data,
  });
};

/** PATCH reorder mixed role + direct-responsibility attachments on a position. */
export const reorderPositionAttachments = (account_id, position_id, attachments) => {
  return axios()({
    method: "patch",
    url: `${API.PROFICIENCY_V2}${account_id}/position/${position_id}/reorder-attachments`,
    data: { attachments },
  });
};

function getAccountId() {
  try {
    return JSON.parse(localStorage.getItem("currentAccountID"));
  } catch {
    return localStorage.getItem("currentAccountID");
  }
}

function jobDescriptionImportBase(positionId) {
  return `${API.ACCOUNT_LIST_V2}${getAccountId()}/position/${positionId}/job-description/`;
}

/**
 * Extract + catalog-match a job-description document (ER-11172 / ER-11619).
 * POST .../position/<id>/job-description/extract/
 */
export const extractJobDescription = ({ positionId, file }) => {
  const formData = new FormData();
  if (file != null) formData.append("file", file);
  return axios()({
    method: "post",
    url: `${jobDescriptionImportBase(positionId)}extract/`,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

/**
 * Execute one per-bullet Import Job Description action (ER-11619).
 * POST .../position/<id>/job-description/execute/
 */
export const executeJobDescriptionSolution = ({ positionId, payload }) => {
  return axios()({
    method: "post",
    url: `${jobDescriptionImportBase(positionId)}execute/`,
    data: payload,
  });
};

/**
 * Generate an IQ-suggested responsibility name + context for a CREATE_NEW bullet
 * (ER-12076).
 * POST .../position/<id>/job-description/suggest-responsibility/
 */
export const suggestJobDescriptionResponsibility = ({ positionId, bullet, signal }) => {
  return axios()({
    method: "post",
    url: `${jobDescriptionImportBase(positionId)}suggest-responsibility/`,
    data: { bullet },
    signal,
  });
};

function buildJobDescriptionImportStreamUrl(positionId) {
  const baseUrl = (configService.get("baseURL") || "").replace(/\/$/, "");
  return `${baseUrl}/${jobDescriptionImportBase(positionId)}extract/stream/`;
}

function processImportSSELine(line, state, onThinkingUpdate) {
  const trimmed = line.trim();

  if (!trimmed) {
    return state;
  }

  if (trimmed.startsWith("event:")) {
    return { ...state, currentEvent: trimmed.slice(6).trim().toLowerCase() };
  }

  if (!trimmed.startsWith("data:")) {
    return state;
  }

  const dataStr = trimmed.slice(5).trim();
  if (!dataStr) {
    return state;
  }

  let data;
  try {
    data = JSON.parse(dataStr);
  } catch {
    return state;
  }

  const eventType = state.currentEvent || "";
  const nextState = { ...state, currentEvent: "" };

  if (eventType === "thought") {
    const chunk = typeof data?.message === "string" ? data.message.trim() : "";
    if (chunk) {
      nextState.reasoning = state.reasoning ? `${state.reasoning}\n${chunk}` : chunk;
      if (onThinkingUpdate) {
        onThinkingUpdate(nextState.reasoning);
      }
    }
    return nextState;
  }

  if (eventType === "result") {
    nextState.result = data;
    return nextState;
  }

  if (eventType === "error") {
    nextState.error = data?.detail || data?.code || "Job description import failed";
    return nextState;
  }

  return nextState;
}

async function readImportSSEStream(reader, onThinkingUpdate) {
  const decoder = new TextDecoder();
  let state = {
    reasoning: "",
    result: null,
    error: null,
    buffer: "",
    currentEvent: "",
  };

  let done = false;
  while (!done) {
    const chunk = await reader.read();
    done = chunk.done;
    if (done) break;

    state.buffer += decoder.decode(chunk.value, { stream: true });
    const lines = state.buffer.split("\n");
    state.buffer = lines.pop() || "";

    for (const line of lines) {
      state = processImportSSELine(line, state, onThinkingUpdate);
    }
  }

  return {
    data: state.result,
    reasoning: state.reasoning,
    error: state.error,
  };
}

/**
 * Extract + catalog-match a job-description document as a streamed SSE import
 * (ER-11680): incremental ``event: thought`` frames while the backend runs the
 * extract + per-bullet match loop, then one ``event: result`` frame carrying the
 * same payload the blocking ``extract/`` endpoint returns.
 *
 * @param {number|string} positionId
 * @param {File} file
 * @param {AbortSignal} [signal]
 * @param {(reasoning: string) => void} [onThinkingUpdate] Called after each thought chunk.
 * @returns {Promise<{data: object, reasoning: string}>}
 */
export const extractJobDescriptionStream = async ({
  positionId,
  file,
  signal,
  onThinkingUpdate,
} = {}) => {
  const formData = new FormData();
  if (file != null) formData.append("file", file);

  const token = localStorage.getItem("token");
  const response = await fetch(buildJobDescriptionImportStreamUrl(positionId), {
    method: "post",
    headers: token ? { Authorization: `Token ${token}` } : {},
    body: formData,
    signal,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const reader = response.body.getReader();
  try {
    const { data, reasoning, error } = await readImportSSEStream(reader, onThinkingUpdate);
    if (error) {
      throw Object.assign(new Error(error), { isErrorFrame: true });
    }
    if (!data) {
      throw new Error("Job description import stream ended without a result.");
    }
    return { data, reasoning };
  } finally {
    reader.releaseLock();
  }
};

/**
 * Start a background job-description import (ER-12737). The upload creates the
 * import on the server; processing continues without the browser.
 * POST .../position/<id>/job-description/import/
 */
export const startJobDescriptionImport = ({ positionId, file, onUploadProgress }) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios()({
    method: "post",
    url: `${jobDescriptionImportBase(positionId)}import/`,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress,
  });
};

/**
 * Load the position's active background import with its items (ER-12737).
 * GET .../position/<id>/job-description/import/active/
 */
export const getActiveJobDescriptionImport = ({ positionId }) => {
  return axios()({
    method: "get",
    url: `${jobDescriptionImportBase(positionId)}import/active/`,
  });
};

/**
 * Save one decision (attach / create / skip) to the server (ER-12737).
 * POST .../position/<id>/job-description/import/<importId>/decision/
 */
export const decideJobDescriptionImportItem = ({ positionId, importId, payload }) => {
  return axios()({
    method: "post",
    url: `${jobDescriptionImportBase(positionId)}import/${importId}/decision/`,
    data: payload,
  });
};

/**
 * End or advance a background import (ER-12737). `cancel` stops processing,
 * `discard-remaining` drops undecided items, `retry` re-runs a failed import,
 * `dismiss` clears a finished or expired one.
 */
const jobDescriptionImportAction = (action) => {
  return ({ positionId, importId }) =>
    axios()({
      method: "post",
      url: `${jobDescriptionImportBase(positionId)}import/${importId}/${action}/`,
    });
};

export const cancelJobDescriptionImport = jobDescriptionImportAction("cancel");
export const discardRemainingJobDescriptionImport = jobDescriptionImportAction("discard-remaining");
export const retryJobDescriptionImport = jobDescriptionImportAction("retry");
export const dismissJobDescriptionImport = jobDescriptionImportAction("dismiss");
